<template>
  <div class="promo">
    <a href="javascript:void (0);" class="item.link" @click="$router.push({ name: 'activeinfo',query:{id:item.id} });">
      <div class="promo-img">
        <img class="img-responsive" :src="safeItem.banner" lazy="loaded" />
        <div class="promo-label">{{ safeItem.type_name }}</div>
      </div>
      <div class="info">
        <div class="title">
          <div class="h3">
            
            {{ safeItem.title }}<div v-if="safeItem.red_dot == 1" class="dot" /></div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ActiveItemView',
  props:['item'],
  computed:{
    safeItem(){
        return this.item || {}
    }
  }
}
</script>
<style lang="scss" scoped>
.promo {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-bottom: 15px;
    border-radius: 8px
}

.promo .promo-img {
    position: relative;
    width: 100%;
    height: 140px;
    overflow: hidden;
    // background: url(../style/default-img.8558dbe5.png) no-repeat 50% #282828;
    border-radius: 8px 8px 0 0;
    margin-bottom: 8px;
    img{
        width: 100%;
        height: 100%;
    }
}

.promo .promo-img .promo-label {
    width: 46px;
    height: 18px;
    line-height: 18px;
    position: absolute;
    right: 0;
    top: 0;
    background-image: linear-gradient(-45deg, #ff3e16, #ff9b2c);
    border-radius: 0 8px 0 8px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    letter-spacing: 0
}

.promo .info {
    display: inline-block;
    width: calc(100% - 20px);
    border-radius: 0 0 8px 8px;
    padding:0 10px
}

.promo .title {
    margin-bottom: 0
}

.promo .title div.h3 {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    line-height: 17px;
    position: relative;
    display: inline-block;
            max-width: 80%;
            padding: 5px 13px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
}

.promo .title div.h3 .dot{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: red;
    position: absolute;
    top: 0px;
    right: 0px;
    border: 1px solid #fff;
}

.promo .title h3 span {
    font-weight: 400
}

.promo .date {
    display: block;
    float: left;
    height: 18px;
    padding: 0 7px;
    font-size: 12px;
    line-height: 20px;
    color: #cca352;
    border: 1px solid #f9cb5c;
    border-radius: 2px;
    margin-bottom: 10px;
    margin-top: 5px
}

.promo p {
    font-size: 14px;
    line-height: 15px;
    letter-spacing: 0;
    color: #999;
    margin-top: 5px
}

.promo .promo-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(20, 20, 20, .8)
}

.promo .promo-mask .promo-txt {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 100%
}

.promo .promo-mask .promo-txt p {
    margin-bottom: 8px;
    font-size: 13px;
    color: #fff
}

.promo .promo-mask .promo-txt a {
    display: block;
    font-size: 13px;
    color: #cca352
}
</style>
